<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="40px" fill="none" viewBox="0 0 32 32">
    <path fill="currentColor" fill-rule="evenodd" d="M15.386 1.877a1 1 0 011.228 0l12 9.334A1 1 0 0129 12v14.667a3.667 3.667 0 01-3.667 3.666H6.667A3.667 3.667 0 013 26.667V12a1 1 0 01.386-.79l12-9.333zM5 12.49v14.178a1.667 1.667 0 001.667 1.666h18.666A1.667 1.667 0 0027 26.667V12.489L16 3.934 5 12.489z" clip-rule="evenodd" />
    <path fill="currentColor" fill-rule="evenodd" d="M11 16a1 1 0 011-1h8a1 1 0 011 1v13.333a1 1 0 11-2 0V17h-6v12.333a1 1 0 11-2 0V16z" clip-rule="evenodd" />
  </svg>
</template>
